import React, { ReactNode } from 'react'
import { Route, Switch } from 'react-router-dom'
import Account from '~app/screens/Account/Account'
import RouteNotFound from '~app/screens/RouteNotFound/RouteNotFound'

interface Props {
  navRoutes: ReactNode[]
}

const AppRoutes: React.FC<Props> = (props) => {
  return <Switch>
    {props.navRoutes}
    <Route path='/account' exact component={Account} />
    <Route component={RouteNotFound} />
  </Switch>
}

export default AppRoutes
